/**
 * @generated SignedSource<<a987866662c9437562476c51028236f5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ExtProjectLinksQuery$variables = Record<PropertyKey, never>;
export type ExtProjectLinksQuery$data = {
  readonly current_user: {
    readonly account: {
      readonly activeTicketingIntegrations: ReadonlyArray<{
        readonly ext_projects: ReadonlyArray<{
          readonly id: number;
          readonly name: string;
          readonly remote_id: string | null | undefined;
        }>;
        readonly id: number;
        readonly integration_service: {
          readonly id: number;
          readonly name: string;
          readonly square_image_url: string | null | undefined;
        };
      }>;
      readonly id: number;
    };
    readonly id: number;
    readonly permissions: any;
  } | null | undefined;
};
export type ExtProjectLinksQuery = {
  response: ExtProjectLinksQuery$data;
  variables: ExtProjectLinksQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "users",
    "kind": "LinkedField",
    "name": "current_user",
    "plural": false,
    "selections": [
      (v0/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "accounts",
        "kind": "LinkedField",
        "name": "account",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": "activeTicketingIntegrations",
            "args": [
              {
                "kind": "Literal",
                "name": "where",
                "value": {
                  "category": {
                    "_eq": "TICKETING"
                  },
                  "state": {
                    "_neq": "PENDING"
                  }
                }
              }
            ],
            "concreteType": "integration",
            "kind": "LinkedField",
            "name": "integrationsV2",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "integration_service",
                "kind": "LinkedField",
                "name": "integration_service",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "square_image_url",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "where",
                    "value": {
                      "deleted": {
                        "_eq": false
                      }
                    }
                  }
                ],
                "concreteType": "ext_project",
                "kind": "LinkedField",
                "name": "ext_projects",
                "plural": true,
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "remote_id",
                    "storageKey": null
                  }
                ],
                "storageKey": "ext_projects(where:{\"deleted\":{\"_eq\":false}})"
              }
            ],
            "storageKey": "integrationsV2(where:{\"category\":{\"_eq\":\"TICKETING\"},\"state\":{\"_neq\":\"PENDING\"}})"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "permissions",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ExtProjectLinksQuery",
    "selections": (v2/*: any*/),
    "type": "query_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ExtProjectLinksQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "9b1287b9e9102c624256373fb7dd2c35",
    "id": null,
    "metadata": {},
    "name": "ExtProjectLinksQuery",
    "operationKind": "query",
    "text": "query ExtProjectLinksQuery {\n  current_user {\n    id\n    account {\n      id\n      activeTicketingIntegrations: integrationsV2(where: {category: {_eq: \"TICKETING\"}, state: {_neq: \"PENDING\"}}) {\n        id\n        integration_service {\n          id\n          name\n          square_image_url\n        }\n        ext_projects(where: {deleted: {_eq: false}}) {\n          id\n          name\n          remote_id\n        }\n      }\n    }\n    permissions\n  }\n}\n"
  }
};
})();

(node as any).hash = "828bdfb910953e6f22e57bc8497f2063";

export default node;
